goog.provide("shadow.js.shim.module$src$svg$wpp$content$key_svg");
goog.provide("module$shadow_js_shim_module$src$svg$wpp$content$key_svg");
shadow.js.shim.module$src$svg$wpp$content$key_svg = shadow.js.nativeProvides["src/svg/wpp/content/key.svg"] = shadow$bridge("src/svg/wpp/content/key.svg");
module$shadow_js_shim_module$src$svg$wpp$content$key_svg.default = shadow.js.shim.module$src$svg$wpp$content$key_svg;
